import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-messenger',
  standalone: true,
  templateUrl: '../../assets/messenger.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamMessengerIcon {}
